import { Cascader } from 'antd';
import { useStore } from '../store/store';
import './CascaderCustom.css';

const CascaderCustom = ({
  tablesToDisplay,
  functionToExec,
  disableCascader = false,
  placeholderToDisplay = 'no placeholder',
  placement = 'bottomLeft',
  sytleCustom,
  selectedBox,
  searchKey = 'label',
  /** Quand défini (y compris `null`), remplace `selectedBox.variablePath` pour la valeur du Cascader */
  displayValue,
  /** Ant Design : évite d'afficher des segments de `value` non string (ex. objets API) */
  displayRender,
  dropdownRender,
}) => {
  const normalizeForSearch = (value) => {
    if (typeof value !== 'string') return '';
    return value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  };

  const cascaderFilter = (inputValue, path) => {
    const normalizedInputValue = normalizeForSearch(inputValue);
    return path.some((option) => {
      const value = option[searchKey];
      return normalizeForSearch(value).includes(normalizedInputValue);
    });
  };
  const { setEventManagerEnabled, addVariablePathToBox, selectedBoxId } =
    useStore(
      ({ setEventManagerEnabled, addVariablePathToBox, selectedBoxId }) => ({
        setEventManagerEnabled,
        addVariablePathToBox,
      })
    );
  return (
    <Cascader
      disabled={disableCascader}
      placement={placement}
      options={tablesToDisplay}
      value={
        displayValue !== undefined
          ? displayValue
          : selectedBox
            ? selectedBox.variablePath
            : null
      }
      onChange={(e, selectedOptions) => {
        functionToExec(e, selectedOptions);
        setEventManagerEnabled(true);
        if (selectedBoxId) addVariablePathToBox(selectedBox?.id, e);
        document.activeElement.blur();
      }}
      placeholder={placeholderToDisplay}
      onFocus={() => {
        setEventManagerEnabled(false);
      }}
      onBlur={() => {
        setEventManagerEnabled(true);
      }}
      showSearch={{
        filter: cascaderFilter,
      }}
      style={{
        borderRadius: '5px',
        ...sytleCustom
      }}
      {...(displayRender ? { displayRender } : {})}
      {...(dropdownRender ? { dropdownRender } : {})}
    />
  );
};
export default CascaderCustom;
